import React, { useEffect } from "react";
import LegalPageLayout from "../components/LegalPageLayout";
import { Link } from "react-router-dom";

const CookiePage = () => {
  useEffect(() => {
    // Add class to body to show reCAPTCHA badge
    document.body.classList.add('cookies-page');
    return () => {
      // Remove class when component unmounts
      document.body.classList.remove('cookies-page');
    };
  }, []);

  return (
  <LegalPageLayout title="Cookie-Richtlinie">
    <p className="text-[var(--vortex-text-secondary)]">
      Diese Cookie-Richtlinie erläutert, welche Cookies und ähnliche
      Technologien auf dieser Website verwendet werden und wie Sie Ihre
      Einstellungen verwalten können. Die Nutzung erfolgt im Einklang mit der
      Datenschutz-Grundverordnung (DSGVO) und dem Telemediengesetz (TMG).
    </p>

    <section>
      <h2 className="text-xl font-semibold text-[var(--vortex-text-primary)] mt-8 mb-2">
        1. Was sind Cookies?
      </h2>
      <p>
        Cookies sind kleine Textdateien, die von Websites auf Ihrem Gerät
        (Computer, Tablet, Smartphone) gespeichert werden. Sie dienen u. a.
        dazu, die Nutzung der Website zu ermöglichen, Einstellungen zu
        speichern oder die Sicherheit zu gewährleisten.
      </p>
    </section>

    <section>
      <h2 className="text-xl font-semibold text-[var(--vortex-text-primary)] mt-8 mb-2">
        2. Welche Cookies setzen wir?
      </h2>
      <p>
        <strong className="text-[var(--vortex-text-primary)]">
          Technisch notwendige Cookies
        </strong>
        <br />
        Diese Cookies sind für den Betrieb der Website erforderlich. Dazu
        gehören z. B. Cookies zur Speicherung Ihrer Cookie-Einwilligung,
        Session-Informationen oder zur Sicherheit (z. B. reCAPTCHA beim
        Kontaktformular). Auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO
        (berechtigtes Interesse) bzw. zur Vertragserfüllung ist hierfür keine
        gesonderte Einwilligung erforderlich.
      </p>
      <p className="mt-4">
        <strong className="text-[var(--vortex-text-primary)]">
          Optionale / Analyse-Cookies
        </strong>
        <br />
        Soweit wir auf dieser Website optionale Cookies (z. B. für Statistik
        oder Marketing) einsetzen, erfolgt dies nur mit Ihrer vorherigen
        Einwilligung. Dazu gehören:
      </p>
      <ul className="list-disc pl-6 mt-2 space-y-1">
        <li>
          <strong className="text-[var(--vortex-text-primary)]">Google Analytics (GA4):</strong>{" "}
          zur Auswertung der Website-Nutzung (z. B. Seitenaufrufe, Herkunft).
          Weitere Informationen in unserer{" "}
          <Link to="/datenschutz" className="text-[var(--vortex-accent-primary)] hover:underline">
            Datenschutzerklärung
          </Link>{" "}
          (Abschnitt Google Analytics).
        </li>
        <li>
          <strong className="text-[var(--vortex-text-primary)]">Microsoft Clarity:</strong>{" "}
          zur Analyse des Nutzerverhaltens (Heatmaps, Session-Aufzeichnungen)
          zur Verbesserung der Website. Weitere Informationen in unserer{" "}
          <Link to="/datenschutz" className="text-[var(--vortex-accent-primary)] hover:underline">
            Datenschutzerklärung
          </Link>{" "}
          (Abschnitt Microsoft Clarity).
        </li>
      </ul>
      <p className="mt-4">
        Sie können Ihre Einwilligung jederzeit über den Link in unserem
        Cookie-Hinweis bzw. über die{" "}
        <Link to="/cookies" className="text-[var(--vortex-accent-primary)] hover:underline">
          Cookie-Richtlinie
        </Link>{" "}
        anpassen.
      </p>
    </section>

    <section>
      <h2 className="text-xl font-semibold text-[var(--vortex-text-primary)] mt-8 mb-2">
        3. Speicherdauer
      </h2>
      <p>
        Session-Cookies werden beim Schließen des Browsers gelöscht.
        Dauerhafte Cookies (z. B. für Ihre Cookie-Einwilligung) bleiben für die
        dort festgelegte Dauer auf Ihrem Gerät gespeichert, bis Sie sie löschen
        oder die Speicherdauer abläuft.
      </p>
    </section>

    <section>
      <h2 className="text-xl font-semibold text-[var(--vortex-text-primary)] mt-8 mb-2">
        4. Ihre Wahl
      </h2>
      <p>
        Sie können Ihren Browser so einstellen, dass Sie über das Setzen von
        Cookies informiert werden oder Cookies einzeln erlauben bzw. ablehnen.
        Die Deaktivierung von Cookies kann die Funktionsfähigkeit dieser
        Website einschränken. Ihre Cookie-Einwilligung können Sie über den
        Cookie-Hinweis auf der Website oder über die{" "}
        <Link to="/cookies" className="text-[var(--vortex-accent-primary)] hover:underline">
          Cookie-Richtlinie
        </Link>{" "}
        bzw. die{" "}
        <Link to="/datenschutz" className="text-[var(--vortex-accent-primary)] hover:underline">
          Datenschutzerklärung
        </Link>{" "}
        anpassen.
      </p>
    </section>

    <section>
      <h2 className="text-xl font-semibold text-[var(--vortex-text-primary)] mt-8 mb-2">
        5. Weitere Informationen
      </h2>
      <p>
        Ausführliche Informationen zur Verarbeitung personenbezogener Daten
        finden Sie in unserer{" "}
        <Link to="/datenschutz" className="text-[var(--vortex-accent-primary)] hover:underline">
          Datenschutzerklärung
        </Link>
        .
      </p>
    </section>

    <section className="mt-8 pt-6 border-t border-[var(--vortex-border)]">
      <p className="text-sm text-[var(--vortex-text-secondary)]">
        Stand: {new Date().toLocaleDateString("de-DE")}.
      </p>
    </section>
  </LegalPageLayout>
  );
};

export default CookiePage;
